import { User, Database, Bell, Shield, Info, CreditCard, Settings, FileText } from 'lucide-react';

// Tab definitions and configuration
export const BASE_TABS = [
  { id: 'general', label: 'General', icon: User },
  { id: 'security', label: 'Security', icon: Shield },
  { id: 'about', label: 'About', icon: Info }
];

export const DATA_TAB = { id: 'data', label: 'Data Management', icon: Database };

export const QUICKBOOKS_TAB = { id: 'quickbooks', label: 'QuickBooks', icon: CreditCard };

export const ADMIN_TAB = { id: 'admin', label: 'Admin Settings', icon: Settings };

export const DOC_LIBRARY_TAB = { id: 'document-library', label: 'Document Library', icon: FileText };

// Default settings values
export const DEFAULT_COMPANY_INFO = {
  companyName: 'PestControl.co.uk',
  contactEmail: 'admin@pestcontrol.co.uk',
  phoneNumber: '+44 (0) 123 456 7890',
  address: '123 Business Street, London, UK'
};

export const DEFAULT_PREFERENCES = {
  defaultAppointmentDuration: 60
};

export const APPOINTMENT_DURATION_OPTIONS = [
  { value: 15, label: '15 Mins' },
  { value: 20, label: '20 Mins' },
  { value: 25, label: '25 Mins' },
  { value: 30, label: '30 Mins' },
  { value: 45, label: '45 Mins' },
  { value: 60, label: '1 Hour' },
  { value: 90, label: '1 Hour 30 Mins' },
  { value: 120, label: '2 Hours' },
  { value: 180, label: '3 Hours' },
  { value: 240, label: '4 Hours' }
];

// Notification settings
export const NOTIFICATION_SETTINGS = [
  {
    id: 'newJobAlerts',
    title: 'New Job Alerts',
    description: 'Get notified when new jobs are created',
    defaultValue: true
  },
  {
    id: 'jobStatusUpdates',
    title: 'Job Status Updates',
    description: 'Get notified when job status changes',
    defaultValue: true
  },
  {
    id: 'dailyReports',
    title: 'Daily Reports',
    description: 'Receive daily summary reports',
    defaultValue: false
  }
];

// Application information
export const APP_INFO = {
  version: '1.2.0',
  technologies: 'React 18, MySQL, Tailwind CSS',
  features: [
    'Client Management',
    'Job Scheduling & Tracking',
    'Treatment Reports',
    'Real-time Data Sync',
    'File Upload & Storage',
    'Interactive Checklists'
  ],
  supportEmail: 'paul@pestcontrol.co.uk'
};

// QuickBooks setup instructions
export const QUICKBOOKS_INSTRUCTIONS = [
  'Go to the QuickBooks Developer Dashboard',
  'Create or select your app',
  'Find your Client ID and Secret in the Keys & OAuth section',
  'Set your Redirect URI to: https://[your-ngrok-url].ngrok-free.app/quickbooks/callback'
];

// API configuration
export const API_CONFIG = {
  NOTIFICATION_AUTO_DISMISS_DELAY: 4000
};

// Error messages
export const ERROR_MESSAGES = {
  QB_CREDENTIALS_REQUIRED: 'Both Client ID and Client Secret are required',
  PERMISSION_DENIED: 'Permission denied. Please ensure you have admin privileges to modify settings.',
  SERVER_ERROR: 'Server error. Please try again later.',
  ACCESS_DENIED: 'Access denied. Admin privileges required.'
};